import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import {
	makeStyles,
	Button
} from '@material-ui/core';

const styles = makeStyles(theme => ({
	button: {
		textAlign: "left",
		marginLeft: theme.spacing(-0.75),
		marginBottom: theme.spacing(1)
	}
}));

function TrendingTopicLinks(props) {
	const handleClick = (e, topic) => {
		e.preventDefault();
		e.stopPropagation();
		props.history.push(`/trends/topics/${topic.trending_topic.id}`);
	};

	let classes = styles(),
		{topics} = props;

	return (
		topics && topics.length ?
			<div>
				{topics.map(topic =>
					<Button
						size="small"
						color="primary"
						className={classes.button}
						key={`key-${topic.id}`}
						onClick={(e) => {handleClick(e, topic);}}>
						{topic.trending_topic.name.replace(/\|/ig, "/")}
					</Button>
				)}
			</div> : null
	);
}

TrendingTopicLinks.propTypes = {
	history: PropTypes.object.isRequired,
	topics: PropTypes.array
};

export default withRouter(TrendingTopicLinks);
